import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { SetCardKeyIsEnabled as SetCardKeyIsEnabledCommand } from '../../api/commands';
import { ForceRefreshStorymap } from './forceRefreshStorymap';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetCardKeyIsEnabled extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetCardKeyIsEnabled';

    public constructor(public isEnabled: boolean, public cardKeyPrefix: string) {
        super(SetCardKeyIsEnabled.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetCardKeyIsEnabled): Promise<boolean> => {
    return useSendCommandAsync(action, {
        createCommand: async () => new SetCardKeyIsEnabledCommand(state.id, action.isEnabled, action.cardKeyPrefix),
    });
};

const reducer = (state: StorymapState, action: SetCardKeyIsEnabled): void => {
    state.isCardKeyEnabled = action.isEnabled;
    state.cardKeyPrefix = action.cardKeyPrefix;

    if (action.isEnabled) {
        dispatch(new ForceRefreshStorymap());
    }
};

//@ts-ignore
registerMiddleware(SetCardKeyIsEnabled.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetCardKeyIsEnabled.ACTION_TYPE, reducer);
